<template>
  <div>
    <v-snackbar :center="true" :timeout="3000" :top="true" color="error" v-model="snackbar">
      {{ notificationMessage }}
      <v-btn @click="snackbar = false" dark text>Close</v-btn>
    </v-snackbar>

    <div class="login-container">
      <v-card class="login-card">
        <v-card-text class="px-7 py-1">

          <!-- Login Form -->
          <v-form v-if="!smsOtpRequired && !twofaenabled" @submit.prevent="check2faEnabled" ref="loginForm">
            <top-header-section text-item="ADMINISTRATIVE PORTAL" />
            <v-text-field :rules="[rules.required]" class="mt-2" label="Mobile Number/Email" outlined
                          prepend-inner-icon="mdi-account color-blue" type="text" v-model="form.username" />
            <v-text-field :append-icon="passwordShow ? 'visibility_off' : 'visibility'" :rules="[rules.required]"
                          :type="passwordShow ? 'text' : 'password'" @click:append="passwordShow = !passwordShow" label="Password"
                          outlined prepend-inner-icon="mdi mdi-lock left-icon color-blue" v-model="form.password" />
            <v-btn class="login-button" color="primary" large type="submit" :loading="loading">LOGIN</v-btn>
<!--            <v-flex class="mt-4" md12 text-center xs12>-->
<!--              <router-link to="/forgot-password">-->
<!--                <v-btn color="primary" small text>Forgot Password ?</v-btn>-->
<!--              </router-link>-->
<!--            </v-flex>-->
          </v-form>


          <!-- SMS OTP Form -->
          <v-form v-if="smsOtpRequired && !twofaenabled" @submit.prevent="submitSmsOtp" ref="smsOtpForm">
            <top-header-section text-item="SMS OTP VERIFICATION" :sub-text-item="otpSubtitle" />
            <v-text-field :rules="[rules.required]" class="mt-2" label="SMS OTP" outlined
                          prepend-inner-icon="mdi-message-text" type="text" v-model="form.sms_otp" ref="sms_otp" />
            <v-btn class="login-button" color="primary" large type="submit" :loading="loading">Verify OTP</v-btn>
          </v-form>


          <!-- TOTP Form -->
          <v-form v-if="twofaenabled" @submit.prevent="submit2Fa" ref="twofaform">
            <top-header-section text-item="2FA AUTHENTICATION"
                                sub-text-item="Open your authenticator application and enter the code below." />
            <v-text-field :rules="[rules.required]" class="mt-2" label="Verification Code" outlined
                          prepend-inner-icon="mdi-shield-check color-blue" type="text" ref="verification_code"
                          v-model="form.verification_code" />
            <v-btn class="login-button" color="primary" large type="submit" :loading="loading">Verify Token</v-btn>
          </v-form>

        </v-card-text>
      </v-card>
    </div>
    <developed-by-item />
  </div>
</template>

<script>
import Http from "axios";
import DevelopedByItem from "../components/DevelopedBy";
import TopHeaderSection from "../components/TopHeaderSection";
import {API_URL, VERSION} from "../config/config";

export default {
  components: { DevelopedByItem, TopHeaderSection },

  data: () => ({
    loading: false,
    snackbar: false,
    notificationMessage: "",
    otpSubtitle: "Enter the code sent to your registered mobile.",
    form: {
      username: "",
      password: "",
      sms_otp: "",
      verification_code: ""
    },
    passwordShow: false,
    twofaenabled: false,
    smsOtpRequired: false,
    rules: {
      required: value => !!value || "Required."
    }
  }),

  methods: {
    async check2faEnabled() {
      if (!this.$refs.loginForm.validate()) return;

      try {
        this.loading = true;
        const response = await this.$oauth.check2FAEnabled(this.form.username, this.form.password);
        const data = response.data.data;

        this.smsOtpRequired = data.sms_otp_required || false;
        this.twofaenabled = data.twofa_enabled || false;
        this.loading = false;

        if (this.smsOtpRequired) {
          this.otpSubtitle = "Use the code sent to your device.";
          setTimeout(() => {
            if (this.$refs.smsOtpForm) {
              this.$refs.smsOtpForm.reset();
            }
            if (this.$refs.sms_otp) {
              this.$refs.sms_otp.focus();
            }
          }, 10);
          return;
        }

        if (this.twofaenabled) {
          setTimeout(() => {
            this.$refs.twofaform.reset();
            this.$refs.verification_code.focus();
          }, 10);
        } else {
          this.oAuthLogin();
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async submitSmsOtp() {
      //https://dev-backend.immigration.gov.np/api/v1/verify-sms-otp
      if (!this.$refs.smsOtpForm.validate()) return;
      try {
        this.loading = true;
        const res = await Http.post(API_URL + VERSION +'/verify-sms-otp', {
          //   username: this.form.username,
          otp: this.form.sms_otp,
          username: this.form.username

        });
        this.loading = false;
        if (res.data.success) {
          this.oAuthLogin();
        } else {
          this.notificationMessage = res.data.message || 'Invalid OTP';
          this.snackbar = true;
        }
      } catch (error) {
        this.loading = false;
        this.notificationMessage = 'OTP verification failed';
        this.snackbar = true;
      }
    },


    submit2Fa() {
      if (this.$refs.twofaform.validate()) {
        this.validate2FAToken();
      }
    },

    async validate2FAToken() {
      try {
        this.loading = true;
        await this.$oauth.validate2FAToken(this.form.username, this.form.password, this.form.verification_code);
        this.oAuthLogin();
      } catch (error) {
        this.handleError(error, "Invalid Verification Code");
      }
    },

    async oAuthLogin() {
      try {
        this.loading = true;
        await this.$oauth.login(this.form.username, this.form.password);
        let redirect = this.$route.query.redirect;
        this.$router.replace(redirect || "/system/dashboard");
      } catch (error) {
        this.handleError(error, "Invalid Username or Password");
      }
    },

    handleError(error, defaultMsg = "An error occurred") {
      if (error.response && error.response.status === 401) {
        this.notificationMessage =  'Invalid Username or Password';

      } else if (error.response && error.response.status === 429) {
        this.notificationMessage = error.response.data.message;
      } else {
        this.notificationMessage = defaultMsg;
      }
      this.snackbar = true;
      this.loading = false;
    }
  }

};
</script>
